export const LOGO = '//cecctm.oss-cn-hangzhou.aliyuncs.com/news/gxhb_logo.ico';
